import { render } from "./IconsManager.vue?vue&type=template&id=c4eb3cce&scoped=true"
const script = {}

import "./IconsManager.vue?vue&type=style&index=0&id=c4eb3cce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4eb3cce"]])

export default __exports__